import { useStaticQuery, graphql } from 'gatsby';

export const useContacts = () => {
	const { contacts } = useStaticQuery(graphql`
		query Contacts {
			contacts: allDatoCmsDropdownContact(sort: { position: ASC }) {
				nodes {
					contactNumber
					secondaryContactNumber
					email
					highlighted
					title
					event
					eventTrigger
				}
			}
		}
	`);

	return { contacts: contacts.nodes };
};
